// extracted by mini-css-extract-plugin
module.exports =  {"header":"_0bc5e8de02--header--AkTGE","heart":"_0bc5e8de02--heart--PSDxx","body":"_0bc5e8de02--body--HBy2Z","close":"_0bc5e8de02--close--zDnoL"};